module.exports = __webpack_public_path__ + "img/pig.d1d8b077.svg";